// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gv","h5Button":"gv","button":"gw","block":"gx","btnDefault":"gy","disable":"gz","btnPrimary":"gA"};